import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { 
  PuzzlePieceIcon, 
  TrophyIcon, 
  ArrowPathIcon,
  GiftIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';

function Home() {
  const { user } = useAuth();

  const menuItems = [
    {
      title: 'Play Quiz',
      description: 'Test your knowledge with our exciting quizzes',
      icon: PuzzlePieceIcon,
      path: '/quiz',
      color: 'bg-gradient-to-r from-blue-500 to-blue-600'
    },
    {
      title: 'Spin Wheel',
      description: 'Try your luck with the spin wheel',
      icon: ArrowPathIcon,
      path: '/spin-wheel',
      color: 'bg-gradient-to-r from-purple-500 to-purple-600'
    },
    {
      title: 'Leaderboard',
      description: 'See where you rank among other players',
      icon: TrophyIcon,
      path: '/leaderboard',
      color: 'bg-gradient-to-r from-green-500 to-green-600'
    },
    {
      title: 'Daily Rewards',
      description: 'Claim your daily rewards',
      icon: GiftIcon,
      path: '/rewards',
      color: 'bg-gradient-to-r from-pink-500 to-pink-600'
    }
  ];

  return (
    <div className="space-y-6">
      {/* User Stats */}
      <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-lg p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="bg-primary-100 dark:bg-primary-900/20 rounded-lg p-3">
              <GiftIcon className="h-6 w-6 text-primary-600 dark:text-primary-400" />
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">Coins</p>
              <p className="text-xl font-semibold text-gray-900 dark:text-white">
                {user?.coins || 0}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <div className="bg-primary-100 dark:bg-primary-900/20 rounded-lg p-3">
              <SparklesIcon className="h-6 w-6 text-primary-600 dark:text-primary-400" />
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">Streak</p>
              <p className="text-xl font-semibold text-gray-900 dark:text-white">
                {user?.streak || 0} days
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Game Options */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className="group relative overflow-hidden rounded-2xl shadow-lg transition-transform duration-300 hover:scale-105"
          >
            <div className={`${item.color} p-6 h-full`}>
              <div className="flex items-start space-x-4">
                <item.icon className="h-8 w-8 text-white" />
                <div className="space-y-2">
                  <h3 className="text-xl font-semibold text-white">
                    {item.title}
                  </h3>
                  <p className="text-white/90">
                    {item.description}
                  </p>
                </div>
              </div>
              <div className="absolute bottom-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
                <item.icon className="h-24 w-24 text-white" />
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Daily Challenge */}
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl p-6 text-white text-center shadow-lg">
        <div className="flex items-center justify-center space-x-2 mb-4">
          <SparklesIcon className="h-6 w-6" />
          <h2 className="text-2xl font-bold">Daily Challenge</h2>
        </div>
        <p className="mb-4">Complete today's quiz to earn bonus points!</p>
        <Link
          to="/quiz"
          className="inline-block bg-white text-blue-600 px-6 py-2 rounded-lg font-semibold hover:bg-blue-50 transition-colors"
        >
          Start Challenge
        </Link>
      </div>
    </div>
  );
}

export default Home; 